import React, { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2'; 
import 'chart.js/auto'; 
import AlertMessage from "../../AlertMessage";
import loadingspinner from '../../assets/images/loading2.gif';


function PresentySheet() {
  const [attendance, setAttendance] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [studentData, setStudentData] = useState([]);
  const [classValue, setClassValue] = useState('');
  const [divisionValue, setDivisionValue] = useState('');

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [savingData, setSavingData] = useState(false);
  const [hasAttendanceData, setHasAttendanceData] = useState(false);
  const [sendingWhatsApp, setSendingWhatsApp] = useState(false);
  const [whatsAppSent, setWhatsAppSent] = useState(false);
  const [lastSubmittedAttendance, setLastSubmittedAttendance] = useState([]);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage(""); 
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);


  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);


  const [chartData, setChartData] = useState({
    labels: ['Present', 'Absent'],
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  });

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);
      
      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
        reject('Error opening IndexedDB');
      };
      
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
      
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
        if (!db.objectStoreNames.contains('attendance')) { // Create attendance object store
          db.createObjectStore('attendance', { keyPath: 'srNo' }); // Ensure srNo is the key
        }
      };
    });
  };

  const udiseNumber = localStorage.getItem("udiseNumber");

  const [classes, setClasses] = useState([]); // To hold class names
  const [divisions, setDivisions] = useState({}); // To hold divisions for each class
  const [allDivisions, setAllDivisions] = useState([]);

  const openDatabase = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        db.createObjectStore('studentData', { keyPath: 'id' });
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onerror = (event) => {
        reject('Error opening database: ' + event.target.errorCode);
      };
    });
  };
const fetchClassDivData = async () => {
  const storedDivClasses = localStorage.getItem("classDiv");
  if (storedDivClasses) {
    const data = JSON.parse(storedDivClasses);
    const classList = [];
    const divisionList = {};
    const activeStudentCounts = {}; // To keep track of active students per class

    // Open the database and fetch all students
    const db = await openDatabase();
    const transaction = db.transaction('studentData', 'readonly');
    const store = transaction.objectStore('studentData');
    const request = store.getAll();

    request.onsuccess = (event) => {
      const allStudents = event.target.result;

      // Count active students for each class
      allStudents.forEach(student => {
        const keyParts = student.id.split('-');
        const currentClass = keyParts.slice(0, -2).join('-'); // Get full class name
        const isActive = student.isActive !== undefined ? student.isActive : true;

        if (isActive) {
          activeStudentCounts[currentClass] = (activeStudentCounts[currentClass] || 0) + 1;
        }
      });

      console.log("Active Student Counts:", activeStudentCounts); // Debugging log

      for (const [className, value] of Object.entries(data)) {
        if (value === true && activeStudentCounts[className] > 0) {
          classList.push(className);
          divisionList[className] = [];
        } else if (typeof value === 'object' && activeStudentCounts[className] > 0) {
          classList.push(className);
          divisionList[className] = Object.keys(value).filter(div => value[div]);
        }
      }

      console.log("Class List:", classList); // Debugging log
      console.log("Division List:", divisionList); // Debugging log

      setClasses(classList);
      setDivisions(divisionList);
    };

    request.onerror = (event) => {
      console.error('Error fetching students:', event.target.error);
    };
  } else {
    console.warn("No classDiv data found in localStorage."); // Debugging log
  }
};

  useEffect(() => {
    fetchClassDivData();
  }, [udiseNumber]);

const fetchStudentData = async () => {
  try {
    setSavingData(true);
    const db = await openIndexedDB();
    const transaction = db.transaction(['studentData'], 'readonly');
    const objectStore = transaction.objectStore('studentData');
    const allRecords = objectStore.getAll();

    allRecords.onsuccess = (event) => {
      const data = event.target.result;

      const filteredData = Object.keys(data)
        .filter(key => data[key] !== null && (data[key].isActive === true || data[key].isActive === undefined)) // Include active students or those without isActive
        .map(key => {
          const student = data[key];
          const srNo = student.id.split('-').pop(); // Extract srNo from id
          return { srNo, ...student }; // Include srNo in the student object
        });

      // Debugging log to see filtered data
      console.log("Filtered Students:", filteredData);

      // Filter students based on selected class
      const studentsInClass = filteredData.filter(student => student.currentClass === classValue);

      // Debugging log to see students in selected class
      console.log("Students in Selected Class:", studentsInClass);

      // If a division is selected, filter by division as well
      const studentsInClassAndDivision = divisionValue 
        ? studentsInClass.filter(student => student.division === divisionValue)
        : studentsInClass; // If no division is selected, include all students in the class

      setStudentData(studentsInClassAndDivision);
    };
  } catch (error) {
    console.error('Error fetching student data:', error);
  } finally {
    setSavingData(false);
  }
};


  
  const handleClassChange = (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass);
    setDivisionValue('');
    
    if (selectedClass && divisions[selectedClass]) {
      const filteredDivisions = divisions[selectedClass].filter(div => div);
    setAllDivisions(filteredDivisions);
  } else {
    setAllDivisions([]);
  }
  };

  const handleDivisionChange = (e) => {
    setDivisionValue(e.target.value);
  };

  useEffect(() => {
    fetchStudentData(); // Fetch students when class or division is selected
  }, [classValue, divisionValue]);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  useEffect(() => {
    if (classValue && divisionValue) {
      const currentDate = new Date(selectedDate);
      const year = currentDate.getFullYear();
      const month = currentDate.toLocaleString('default', { month: 'short' });
      const day = currentDate.getDate();
  
      fetchAttendanceData(year, month, day);
    }
  }, [classValue, divisionValue, selectedDate]);

  const fetchAttendanceData = async (year, month, day) => {
  try {
    const db = await openIndexedDB();
    const transaction = db.transaction(['attendance'], 'readonly');
    const objectStore = transaction.objectStore('attendance');

    const attendancePromises = studentData.map(async (student) => {
      const request = objectStore.get(student.srNo);
      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data && data.Presenty && data.Presenty.Presenty && data.Presenty.Presenty[year] && data.Presenty.Presenty[year][month] && data.Presenty.Presenty[year][month][day]) {
            resolve({ srNo: student.srNo, present: data.Presenty.Presenty[year][month][day].present === 'present' });
          } else {
            resolve({ srNo: student.srNo, present: false });
          }
        };

        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    });

    const fetchedAttendance = await Promise.all(attendancePromises);
    setAttendance(fetchedAttendance);
    calculateChartData(fetchedAttendance);
    
    // Check if any student has attendance data for this date
    const hasData = fetchedAttendance.some(student => 
      student.present !== false // If any student has actual attendance data (not just default false)
    );
    setHasAttendanceData(hasData);
  } catch (error) {
    console.error('Error fetching attendance:', error);
    setAlertMessage('Failed to fetch attendance data. Please try again.');
    setHasAttendanceData(false);
  }
};

  const toggleAttendance = (srNo) => {
    const updatedAttendance = attendance.map((student) => {
      if (student.srNo === srNo) {
        return { ...student, present: !student.present }; // Toggle the present status
      }
      return student;
    });
    setAttendance(updatedAttendance);
    calculateChartData(updatedAttendance); // Recalculate chart when attendance is toggled
  };
  // ?
  const handleSubmit = async () => {
    const currentDate = new Date(selectedDate);
    const year = currentDate.getFullYear();
    const month = currentDate.toLocaleString('default', { month: 'short' });
    const day = currentDate.getDate();
  
    try {
      // Step 1: Save attendance to Firebase
      const promises = attendance.map(async (student) => {
        const attendanceData = { present: student.present ? 'present' : 'absent' };
  
        // Use srNo for the Firebase path
        const response = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/Attendance/${student.srNo}/Presenty/${year}/${month}/${day}.json`,
          {
            method: 'PATCH', // Use PATCH to append data
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(attendanceData),
          }
        );
  
        if (!response.ok) {
          throw new Error(`Failed to submit attendance for student ${student.srNo}`);
        }
      });
  
      await Promise.all(promises); // Wait for all Firebase saves to complete
      setAlertMessage('Attendance submitted successfully!');
      
      // Save snapshot for WhatsApp sending
      setLastSubmittedAttendance([...attendance]);
      setWhatsAppSent(false);
  
      // Step 2: Save attendance to IndexedDB
      await saveAttendanceToIndexedDB(attendance, year, month, day);

      setHasAttendanceData(true);
  
      // Step 3: Fetch updated attendance from IndexedDB
      await fetchAttendanceData(year, month, day);
    } catch (error) {
      console.error('Error submitting attendance:', error);
      setAlertMessage('Failed to submit attendance. Please try again.');
    }
  };

  const sendAttendanceOnWhatsApp = async () => {
    if (!udiseNumber) return;
    setSendingWhatsApp(true);

    try {
      // Fetch school's WhatsApp config from Firebase
      const configRes = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/whatsappConfig.json`
      );
      const whatsappConfig = await configRes.json();

      if (!whatsappConfig || !whatsappConfig.enabled || !whatsappConfig.attendanceWebhook) {
        setAlertMessage('WhatsApp attendance is not configured or disabled for this school.');
        setSendingWhatsApp(false);
        return;
      }

      const webhookTemplate = whatsappConfig.attendanceWebhook;
      const schoolName = localStorage.getItem('schoolName') || 'School';
      const formattedDate = new Date(selectedDate).toLocaleDateString('en-GB');

      // Send a message for each student
      const sendPromises = studentData.map(async (student) => {
        const attRecord = lastSubmittedAttendance.find(a => a.srNo === student.srNo);
        const status = attRecord?.present ? 'Present' : 'Absent';

        // Prepare the parent's phone number: ensure it has 91 prefix
        let phone = (student.fMobile || '').toString().trim().replace(/\D/g, '');
        if (!phone) return; // Skip if no phone number
        if (!phone.startsWith('91')) phone = '91' + phone;

        const studentName = `${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`.trim();
        const remark = attRecord?.present ? 'On Time' : 'Please ensure regular attendance';

        // Replace all template variables in the webhook URL
        let url = webhookTemplate
          .replace(/number=[^&]+/, `number=${phone}`)
          .replace(/studentname/gi, encodeURIComponent(studentName))
          .replace(/attendancestatus/gi, encodeURIComponent(status))
          .replace(/date/gi, encodeURIComponent(formattedDate))
          .replace(/class/gi, encodeURIComponent(classValue))
          .replace(/division/gi, encodeURIComponent(divisionValue))
          .replace(/schoolname/gi, encodeURIComponent(schoolName))
          .replace(/remark/gi, encodeURIComponent(remark))
          .replace(/contactnumber/gi, encodeURIComponent(phone));

        try {
          await fetch(url, { method: 'GET', mode: 'no-cors' });
        } catch (err) {
          console.warn(`WhatsApp failed for ${studentName}:`, err);
        }
      });

      await Promise.all(sendPromises);
      setWhatsAppSent(true);
      setAlertMessage('WhatsApp messages sent to all parents successfully!');
    } catch (error) {
      console.error('Error sending WhatsApp:', error);
      setAlertMessage('Failed to send WhatsApp messages. Please try again.');
    } finally {
      setSendingWhatsApp(false);
    }
  };
  
  const saveAttendanceToIndexedDB = async (attendance, year, month, day) => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['attendance'], 'readwrite');
      const objectStore = transaction.objectStore('attendance');
  
      for (const student of attendance) {
        const srNo = student.srNo; // Use srNo as the key
        const presentStatus = { present: student.present ? 'present' : 'absent' };
  
        // Get the existing record for the student
        const existingRecord = await new Promise((resolve, reject) => {
          const request = objectStore.get(srNo);
          request.onsuccess = (event) => {
            resolve(event.target.result);
          };
          request.onerror = (event) => {
            reject(event.target.error);
          };
        });
  
        if (existingRecord) {
          // Ensure Presenty is initialized
          const presenty = existingRecord.Presenty || {};
          const yearData = presenty.Presenty || {};
          const monthData = yearData[year] || {};
          const dayData = monthData[month] || {};
  
          // If the record exists, update the existing record
          if (!presenty.Presenty) {
            presenty.Presenty = {};
          }
          if (!presenty.Presenty[year]) {
            presenty.Presenty[year] = {};
          }
          if (!presenty.Presenty[year][month]) {
            presenty.Presenty[year][month] = {};
          }
          presenty.Presenty[year][month][day] = presentStatus;
  
          const updatedRecord = {
            srNo: existingRecord.srNo, // Keep the srNo
            Presenty: presenty
          };
          await objectStore.put(updatedRecord, srNo); // Update the record with srNo as the key
        } else {
          // If it doesn't exist, create a new record
          const newRecord = {
            srNo, // Ensure srNo is defined
            Presenty: {
              Presenty: {
                [year]: {
                  [month]: {
                    [day]: presentStatus // Store the present status for the specific day
                  }
                }
              }
            }
          };
          await objectStore.put(newRecord, srNo); // Use srNo as the key
        }
      }
  
      await transaction.complete;
      console.log('Attendance saved to IndexedDB successfully.');
// Reset attendance for the current view
    const resetAttendance = studentData.map(student => ({
      srNo: student.srNo,
      present: false
    }));
    
    setAttendance(resetAttendance);
    calculateChartData(resetAttendance);
    
    // Set attendance data exists to false after marking as holiday
    setHasAttendanceData(false);
    
    setAlertMessage(language === "English" 
      ? "Attendance marked successfully!" 
      : "उपस्थिती यशस्वीरित्या चिन्हांकित केली!");
  } catch (error) {
      console.error('Error saving attendance to IndexedDB:', error);
    }
  };

  const markAsHoliday = async () => {
  if (!window.confirm(language === "English" 
    ? "Are you sure you want to mark this day as a holiday? This will delete all attendance data for this day." 
    : "तुम्हाला खात्री आहे की तुम्हाला हा दिवस सुट्टी म्हणून चिन्हांकित करायचा आहे? यामुळे या दिवसाचा सर्व उपस्थिती डेटा हटवला जाईल.")) {
    return;
  }

  try {
    setSavingData(true);
    const currentDate = new Date(selectedDate);
    const year = currentDate.getFullYear();
    const month = currentDate.toLocaleString('default', { month: 'short' });
    const day = currentDate.getDate();

    // Delete from Firebase
    const deletePromises = studentData.map(async (student) => {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/Attendance/${student.srNo}/Presenty/${year}/${month}/${day}.json`,
        {
          method: 'DELETE',
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to delete attendance for student ${student.srNo}`);
      }
    });

    await Promise.all(deletePromises);

    // Delete from IndexedDB
    const db = await openIndexedDB();
    const transaction = db.transaction(['attendance'], 'readwrite');
    const objectStore = transaction.objectStore('attendance');

    for (const student of studentData) {
      const srNo = student.srNo;
      const existingRecord = await new Promise((resolve, reject) => {
        const request = objectStore.get(srNo);
        request.onsuccess = (event) => resolve(event.target.result);
        request.onerror = (event) => reject(event.target.error);
      });

      if (existingRecord && existingRecord.Presenty && existingRecord.Presenty.Presenty) {
        // Remove the specific day from the record
        if (existingRecord.Presenty.Presenty[year] &&
            existingRecord.Presenty.Presenty[year][month] &&
            existingRecord.Presenty.Presenty[year][month][day]) {
          delete existingRecord.Presenty.Presenty[year][month][day];
          
          // If the month is now empty, remove it
          if (Object.keys(existingRecord.Presenty.Presenty[year][month]).length === 0) {
            delete existingRecord.Presenty.Presenty[year][month];
            
            // If the year is now empty, remove it
            if (Object.keys(existingRecord.Presenty.Presenty[year]).length === 0) {
              delete existingRecord.Presenty.Presenty[year];
            }
          }
          
          // Update the record in the database
          await objectStore.put(existingRecord);
        }
      }
    }

    await transaction.complete;
    
    // Reset attendance for the current view
    const resetAttendance = studentData.map(student => ({
      srNo: student.srNo,
      present: false
    }));
    
    setAttendance(resetAttendance);
    calculateChartData(resetAttendance);
    
    setAlertMessage(language === "English" 
      ? "Day marked as holiday successfully!" 
      : "दिवस यशस्वीरित्या सुट्टी म्हणून चिन्हांकित केला!");
  } catch (error) {
    console.error('Error marking as holiday:', error);
    setAlertMessage(language === "English" 
      ? "Failed to mark as holiday. Please try again." 
      : "सुट्टी म्हणून चिन्हांकित करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.");
  } finally {
    setSavingData(false);
  }
};




  const filteredStudents = studentData.filter(student => 
    student.currentClass === classValue && student.division === divisionValue
  );

  const calculateChartData = (attendanceList) => {
    const totalStudents = filteredStudents.length;
    const presentCount = attendanceList.filter(student => student.present).length;
    const absentCount = totalStudents - presentCount;

    const data = {
      labels: ['Present', 'Absent'],
      datasets: [
        {
          data: [presentCount, absentCount],
          backgroundColor: ['#36A2EB', '#FF6384'],
        },
      ],
    };
    setChartData(data);
  };

  const markAllPresent = () => {
    // Check if all students are already marked as present
    const allPresent = attendance.every((student) => student.present);
  
    // Toggle attendance based on the current state
    const updatedAttendance = studentData.map((student) => ({
      srNo: student.srNo,
      present: !allPresent, // Reverse the state
    }));
  
    setAttendance(updatedAttendance);
    calculateChartData(updatedAttendance); // Recalculate chart data
  };
  const sortClasses = (classes, language) => {
    const classOrder = {
      "Class I": 1,
      "Class II": 2,
      "Class III": 3,
      "Class IV": 4,
      "Class V": 5,
      "Class VI": 6,
      "Class VII": 7,
      "Class VIII": 8,
      "Class IX": 9,
      "Class X": 10,
      "Class XI": 11,
      "Class XII": 12,
      "इयत्ता पहिली": 1,
      "इयत्ता दुसरी": 2,
      "इयत्ता तिसरी": 3,
      "इयत्ता चौथी": 4,
      "इयत्ता पाचवी": 5,
      "इयत्ता सहावी": 6,
      "इयत्ता सातवी": 7,
      "इयत्ता आठवी": 8,
      "इयत्ता नववी": 9,
      "इयत्ता दहावी": 10,
      "इयत्ता अकरावी": 11,
      "इयत्ता बारावी": 12,
    };
  
    return classes.sort((a, b) => classOrder[a] - classOrder[b]);
  };
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' , marginTop:'80px'}}>
  <AlertMessage message={alertMessage} show={showAlert} />
  {savingData && <img width={'80px'} className="registerLoading" src={loadingspinner} style={{top:'50%', left:'50%'}}/>}

  <div style={{ flex: 1, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', width: '800px', height: '100%', overflowY: 'auto' }}>
      <div className="p-4 bg-light rounded shadow">
        <h3 style={{color:'rgb(3, 54, 94)', fontWeight:'600' }} className="text-center mb-4">{language === "English" ? "Attendance Sheet" : "उपस्थिती पत्रक"}</h3>

       

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div style={{ width: '50%', paddingRight: '10px' }}>
            <table className="table table-bordered mb-4" style={{ width: '100%', marginLeft: '0px' }}>
              <tbody>
                <tr>
                  <th>{language === "English" ? "Class" : "वर्ग"}</th>
                  <td>
                    <select
                      id="class"
                      value={classValue}
                      onChange={handleClassChange}
                      className="form-select"
                    >
                      <option value="">{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
                      {classes.map((cls, index) => (
                        <option key={index} value={cls}>
                          {cls}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <th>{language === "English" ? "Division" : "तुकडी"}</th>
                  <td>
                    <select
                      id="division"
                      value={divisionValue}
                      onChange={handleDivisionChange}
                      className="form-select"
                    >
                      <option value="">{language === "English" ? "Select Division" : "तुकडी निवडा"}</option>
                      {allDivisions.map((div, index) => (
                        <option key={index} value={div}>
                          {div}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="mb-3">
          <input
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            className="form-control"
            style={{ width: '200px', display: 'inline-block' }}
          />
        </div>
          </div>
          

          <div style={{ width: '50%', paddingLeft: '10px' }}>
            <div style={{ width: '150px', height: '150px', margin: '0 auto' }}>
              <Pie data={chartData} />
            </div>
          </div>
        </div>

        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <table
            className={`table table-bordered ${
              !(classValue && divisionValue) ? 'disabled-table' : ''
            }`}
          >
            <thead>
              <tr>
                <th>{language === "English" ? "Roll No" : "हजेरी क्र."}</th>
                <th style={{ width: '50%' }}>{language === "English" ? "Name" : "नाव"}</th>
                <th>{language === "English" ? "Present/Absent" : "उपस्थित/अनुपस्थित"}</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th>
                  <button
                    className="btn btn-success mb-3"
                    onClick={markAllPresent}
                    disabled={!(classValue)} 
                  >
                    Mark All{" "}
                    {attendance.every((student) => student.present) ? "Absent" : "Present"}
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
  {classValue ? (
    studentData.length > 0 ? (
      studentData
        .sort((a, b) => a.rollNo - b.rollNo) 
        .map((student) => (
          <tr key={student.srNo}>
            <td>{student.rollNo}</td>
            <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
            <td>
  <button
    className={`btn ${
      attendance.find((att) => att.srNo === student.srNo)?.present
        ? 'btn-success'
        : 'btn-danger'
    }`}
    onClick={() => toggleAttendance(student.srNo)}
  >
    {attendance.find((att) => att.srNo === student.srNo)?.present
      ? 'Present'
      : 'Absent'}
  </button>
</td>
          </tr>
        ))
    ) : (
      <tr>
        <td colSpan="3" className="text-center">
          {language === "English"
            ? "No students found for the selected class."
            : "निवडलेल्या वर्गासाठी कोणतेही विद्यार्थी सापडले नाहीत."}
        </td>
      </tr>
    )
  ) : (
    <tr>
      <td colSpan="3" className="text-center">
        {language === "English"
          ? "Please select a class to view students."
          : "विद्यार्थ्यांना पाहण्यासाठी वर्ग निवडा."}
      </td>
    </tr>
  )}
</tbody>
          </table>
        </div>
        <div className="d-flex flex-wrap gap-2 align-items-center mt-2">
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={!classValue}
          >
            {language === "English" ? "Submit Attendance" : "Save Attendance"}
          </button>

          {lastSubmittedAttendance.length > 0 && (
            <button
              className="btn ms-2"
              style={{
                backgroundColor: whatsAppSent ? '#25D366' : '#128C7E',
                color: 'white',
                fontWeight: '600',
                border: 'none'
              }}
              onClick={sendAttendanceOnWhatsApp}
              disabled={sendingWhatsApp}
            >
              {sendingWhatsApp ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Sending...
                </>
              ) : whatsAppSent ? (
                '✅ WhatsApp Sent'
              ) : (
                '📲 Send Attendance on WhatsApp'
              )}
            </button>
          )}

          {hasAttendanceData && (
            <button
              className="btn btn-warning ms-2"
              onClick={markAsHoliday}
              disabled={!classValue || !selectedDate}
            >
              {language === "English" ? "Mark as Holiday" : "सुट्टी म्हणून चिन्हांकित करा"}
            </button>
          )}
        </div>



      </div>
    </div>
  </div>
</div>
  );
}

export default PresentySheet;